/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { Search, Sparkles, Play } from "lucide-react";
import MainHeader from "../MainHeader";

export default function AgentList() {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);

  /* ─ 목록 가져오기 ─ */
  useEffect(() => {
    api.get("/multimodal-agent/list").then(({ data }) => setAgents(data));
  }, [api]);

  /* ─ 카드 ─ */
  const AgentCard = ({ agent }) => (
    <div
      onClick={() => navigate(`/agent_exec?x_id=${agent.agent_id}`)}
      className="relative group cursor-pointer bg-white rounded-2xl shadow-lg
                 hover:shadow-2xl transform hover:-translate-y-2 transition p-6
                 border border-gray-100"
    >
      <div className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs bg-slate-100 text-slate-700">
        {agent.agent_category || "AI"}
      </div>

      <div className="pt-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-1">
          {agent.agent_title}
        </h3>
        <p className="text-sm text-gray-600 line-clamp-3">
          {agent.agent_description}
        </p>
      </div>

      <div
        className="absolute inset-0 bg-gradient-to-t from-blue-600/90 to-transparent opacity-0
                      group-hover:opacity-100 transition flex items-end pointer-events-none"
      >
        <div className="p-6 text-white text-sm flex items-center gap-2">
          <Play className="w-4 h-4" />
          클릭하여 실행하기
        </div>
      </div>
    </div>
  );

  /* ─ 렌더 ─ */
  return (
    <>
      <MainHeader />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        {/* 헤더 */}
        <div className="sticky top-0 z-40 bg-gradient-to-r from-white via-slate-50 to-white/70 backdrop-blur-md shadow-sm">
          <div className="px-8 py-5 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Sparkles className="w-8 h-8 text-indigo-600" />
              <div>
                <h1 className="text-2xl font-extrabold tracking-tight text-gray-800">
                  Elva, a smart work tool
                </h1>
                <p className="text-xs text-gray-500">
                  당신의 업무를 가속화할&nbsp;{agents.length}개의 스마트
                  에이전트
                </p>
              </div>
            </div>

            <button
              onClick={() => alert("🚧  현재 기능은 준비 중입니다!")}
              className="inline-flex items-center gap-2 rounded-lg bg-indigo-50 px-4 py-2
                               text-sm font-semibold text-indigo-600 shadow-sm
                               hover:bg-indigo-100 active:scale-[.98] transition"
            >
              <Sparkles className="w-4 h-4" />
              새로운 에이전트 제안
            </button>
          </div>
        </div>

        {/* 그리드 */}
        <div className="px-6 py-8">
          {agents.length ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {agents.map((agent) => (
                <AgentCard key={agent.agent_id} agent={agent} />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-64">
              <Search className="w-12 h-12 text-gray-300 mb-4" />
              <p className="text-gray-500">로딩 중…</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
